import React, { useContext, useMemo } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// components
import { EditorContext } from '../../context/EditorContext';

import useComponentTypesQuery from '../../hooks/component-types/useComponentTypesQuery';

import { AlternateHeaderChildrenType } from '../../models/formula.model';

import FormulaAlternateVariantDataView from '../formulaCreate/formulaAlternate/FormulaAlternateVariantDataView';

interface FormulaSidebarVariantProps {
    data: any;
    formulaId: number;
    selectedElement: { [key: string]: any };
}
export default function FormulaSidebarVariant(
    props: React.PropsWithChildren<FormulaSidebarVariantProps>,
) {
    const {
        editorDetails: { formula },
    } = useContext(EditorContext);

    const { data: componentTypes } = useComponentTypesQuery();

    const componentTypeData = useMemo(() => {
        return componentTypes?.mapById[props.data.component_type_id as string];
    }, [props.data.component_type_id, componentTypes]);

    const headerName = useMemo<string>(
        () => componentTypeData?.name ?? '',
        [componentTypeData],
    );

    const childData = useMemo<AlternateHeaderChildrenType>(
        () => ({
            headerName: headerName,
            kind: props.selectedElement.kind,
            variantType: props.selectedElement.variantType,
            id: props.selectedElement.elementId,
        }),
        [headerName, props.selectedElement],
    );

    return (
        <Container>
            <FormulaAlternateVariantDataView
                headerName={headerName}
                childData={childData}
                formulaId={formula?.id ?? props.formulaId}
                isEditable={false}
                selectedElement={props.selectedElement}
            />
        </Container>
    );
}

const Container = styled.div({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'flex-start',
    overflowY: 'auto',
    width: '100%',
    borderRight: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    borderBottom: `1px solid ${aampeTheme.colors.interactiveWG01}`,
    borderTop: `1px solid ${aampeTheme.colors.interactiveWG01}`,
});
